import Vue from 'vue';
import url from 'url';
import qs from 'qs';
import Debug from '~/utils/debug';
import { store } from '~/store';

const debug = Debug('adapi');

let apiKey = () => null;
let apiUrl = () => null;

export class AdapiError extends Error {
  constructor(errors, code, result) {
    super(Array.isArray(errors) ? errors[0] : errors);
    this.errors = errors;
    this.code = code;
    this.result = result;
  }

  toString() {
    return Array.isArray(this.errors) ? this.errors[0] : this.errors;
  }

  valueOf() {
    return this.errors;
  }
}

export const setVuexGetters = (keyGetter, urlGetter) => {
  apiKey = keyGetter;
  apiUrl = urlGetter;
};

export const eventBus = new Vue();

const POST = 'POST';
const GET = 'GET';
const HEAD = 'HEAD';
const PATCH = 'PATCH';
// const DELETE = 'DELETE';

const ADAPI_VERSION = 'v1';

function buildRequest(method, path, query, body) {
  // TODO: this should probably be re-done somehow..
  const requestUrl = store ? store.getters['apiUrl/getUrl'] : apiUrl();
  const requestApiKey = store ? store.getters['auth/getKey'] : apiKey();
  let target = url.resolve(`${requestUrl}${ADAPI_VERSION}/`, path.replace(/^\//, ''));
  target = url.parse(target, true, true);
  target.search = qs.stringify(Object.assign(target.query, query || {}));
  target = url.format(target);

  const headers = new Headers();
  headers.set('Content-Type', 'application/json');


  if (requestApiKey) {
    headers.set('Authorization', `Bearer ${requestApiKey}`);
  }

  debug.debug('new request: %s %s %squery: %o, body: %o', method, path, requestApiKey ? '(authed) ' : '', query, body);

  return new Request(target, {
    method,
    headers,
    body: (method === GET || method === HEAD) ? undefined : JSON.stringify(body),
  });
}

const ongoingRequests = {};

function rawRequest(method, path, query = null, body = null) {
  const cacheKey = JSON.stringify([method, path, query, body]);
  if ((method === GET || method === HEAD) && ongoingRequests[cacheKey]) {
    debug.info('from ongoing request cache: %s %s query: %o, body: %o', method, path, query, body);
    return ongoingRequests[cacheKey].then();
  }

  const request = buildRequest(method, path, query, body);

  eventBus.$emit('start');
  const response = fetch(request)
    .then(res => res.json())
    .then(res => {
      if (res.diff) {
        debug.warn('Diff in format outputs. req: %o, res: %o', request, res);
      }
      return res;
    })
    .then(res => {
      if (res.errors) {
        throw res;
      }
      return res.result;
    })
    .catch(err => {
      ongoingRequests[cacheKey] = null;
      eventBus.$emit('error');
      throw new AdapiError(
        err.errors ? err.errors : [String(err)],
        err.meta ? err.meta.status_code : '?',
        err,
      );
    })
    .then(res => {
      ongoingRequests[cacheKey] = null;
      eventBus.$emit('done');
      return res;
    });

  ongoingRequests[cacheKey] = response;
  return response.then();
}

export function get(path, query) {
  return rawRequest(GET, path, query);
}

export function post(path, query, body) {
  return rawRequest(POST, path, query, body);
}

export function patch(path, query, body) {
  return rawRequest(PATCH, path, query, body);
}

export function translateAdapiErrors(errors, translator) {
  let errorMsgs = '';
  Object.values(errors).forEach(errItem => {
    let subErrors = [];
    try {
      subErrors = JSON.parse(errItem);
    } catch (err) {
      subErrors = [errItem];
    }
    subErrors.forEach(item => {
      if (errorMsgs !== '') {
        errorMsgs = `${errorMsgs}. `;
      }
      let errorKey = item.replace(/\./g, '').replace(/ /g, '-').toLowerCase();
      errorKey = `terms.api-error.${errorKey}`;
      const curErMsg = translator(errorKey);
      if (curErMsg === errorKey) {
        errorMsgs += item;
      } else {
        errorMsgs += curErMsg;
      }
    });
  });
  return errorMsgs;
}



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/utils/adapi.js